<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        <template v-if="name === 'clock'"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></template>
        <path v-else-if="name === 'shield'" d="M12 3 4 6v6c0 4.5 3.4 8.3 8 9 4.6-.7 8-4.5 8-9V6z" />
        <template v-else-if="name === 'briefcase'"><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M9 7V5h6v2" /></template>
        <path v-else-if="name === 'swap'" d="M7 7h11l-3-3M17 17H6l3 3" />
        <template v-else-if="name === 'search'"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></template>
        <template v-else-if="name === 'undo'"><path d="M9 14 4 9l5-5" /><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" /></template>
        <path v-else-if="name === 'trash'" d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />
        <path v-else-if="name === 'plus'" d="M12 5v14M5 12h14" />
        <path v-else-if="name === 'chevron'" d="m6 9 6 6 6-6" />
        <path v-else-if="name === 'check'" d="M5 12l5 5L20 7" />
    </svg>
</template>

<script setup lang="ts">
// RD-163: линейные иконки раздела «Настройки» по макету D (локально, общие icons не меняются).
withDefaults(defineProps<{
    name: 'clock' | 'shield' | 'briefcase' | 'swap' | 'search' | 'undo' | 'trash' | 'plus' | 'chevron' | 'check'
    size?: number
    strokeWidth?: number
}>(), {
    size: 18,
    strokeWidth: 1.8,
})
</script>
